import { render, staticRenderFns } from "./fallback-facet.vue?vue&type=template&id=cd7a11b4&"
import script from "./fallback-facet.vue?vue&type=script&lang=ts&"
export * from "./fallback-facet.vue?vue&type=script&lang=ts&"
import style0 from "./fallback-facet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports